import {Bookmarks} from "./Bookmarks";

export class SearchResult extends Bookmarks{
  suggestions : number[] = [];
}
